export default __webpack_public_path__ + "static/media/not-helpful-reaction-yellow.d40b2433.svg";